import cloneDeep from 'lodash/cloneDeep';
import {
  updateData,
  updateSupportData,
  jump,
  randomAccessJump,
  DO_BACKUP,
} from '../../../AdvWorkflow/AdvWorkflowActions';
import { ITERATOR_POST_END } from '../../../AdvWorkflow/AdvWorkflowHelpers';

const clearStagedGoal = (operation, key, workflowId, clientId, dispatch) => {
  const dataSequence = [null, {}];
  dataSequence.forEach((element) => {
    dispatch(operation(
      {
        [key]: element,
      },
      workflowId,
      clientId,
    ));
  });
};

export const onGoalEdit = (educationGoal, workflowId, clientId) => (dispatch) => {
  dispatch(updateSupportData(
    {
      EducationTypeOptions: {
        ...cloneDeep(educationGoal),
      },
      PersonalInfo: {
        SelectedChildFirstName: educationGoal.Name,
      },
      BlockAutoOutput: true,
    },
    workflowId,
  ));
  dispatch(randomAccessJump(workflowId, clientId, ITERATOR_POST_END));
};

export const onAddNewGoal = (workflowId, clientId) => (dispatch) => {
  clearStagedGoal(updateData, 'EducationGoal', workflowId, clientId, dispatch);
  clearStagedGoal(updateSupportData, 'EducationTypeOptions', workflowId, clientId, dispatch);
  dispatch(updateSupportData(
    {
      BlockAutoOutput: false,
    },
    workflowId,
  ));
  dispatch(jump(1, workflowId, clientId));
};

export const onGoalDelete = (goalId, educationGoals, workflowId, clientId) => async (dispatch) => {
  const {
    ADV: {
      util: { request },
    },
  } = window;

  const response = await request({
    uri: 'Consumer/GoalUpdate/Delete',
    type: 'POST',
    data: {
      clientId,
      goalId,
    },
  });

  if (response.success) {
    dispatch(updateData(
      {
        EducationGoals: educationGoals.filter(({ Id }) => Id !== goalId),
      },
      workflowId,
      clientId,
    ));
    dispatch({
      type: DO_BACKUP,
      workflowId,
      clientId,
    });
  }
};
